export default __webpack_public_path__ + "static/media/about_banner.05594e0b.png";